import axios from "axios";

const Http = axios.create({
  baseURL: "/",
  // headers: {
  //   "X-RapidAPI-Key": "7cdb82a2d0msh554fb9e264e8e1dp1b1616jsna67c367935a3",
  //   "X-RapidAPI-Host": "asos2.p.rapidapi.com",
  // },
});
export default Http;
